import { render, staticRenderFns } from "./footer-mob.vue?vue&type=template&id=091fea00&scoped=true"
import script from "./footer-mob.vue?vue&type=script&lang=js"
export * from "./footer-mob.vue?vue&type=script&lang=js"
import style0 from "./footer-mob.vue?vue&type=style&index=0&id=091fea00&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "091fea00",
  null
  
)

export default component.exports